export const PRISMIC_CLI_NPM_PACKAGE_NAME = "@prismicio/cli";
